import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ConfigComponent } from './config.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        ConfigComponent
    ],
    exports: [
        ConfigComponent
    ]
})

export class ConfigModule { }
